import { render, staticRenderFns } from "./PFDeregLeaverList.vue?vue&type=template&id=4faf96b7"
import script from "./PFDeregLeaverList.vue?vue&type=script&lang=js"
export * from "./PFDeregLeaverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports